
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  Flits.extend({
    redirectToCheckout: async function (parameters) {
      parameters = parameters || {};
      var form = Flits(Flits.StoreCreditCart.settings.checkoutFormSelectors.join(','));
      if (form.length <= 0) {
        // location.href = "/checkout?" + Flits.param(parameters);   
        location.href = location.origin+"/discount/"+parameters?.discount+"?redirect=/checkout";
        return true;
      }
      fetch(`/discount/${parameters?.discount}`)
        .then(function() {
            var form_action = form.attr("action");
            var form_action_data = Flits.parseURL(form_action);
      
            Flits.each(parameters, function (index, item) {
              var existing = form.find("[name='" + index + "']");
              if (existing.length <= 0) {
                form.append("<input type='hidden' name='" + index + "' value='" + item + "'>");
              } else {
                existing.val(item);
              }
              if (form_action_data.searchObject[index]) {
                form_action = form_action.replace(index + '=' + form_action_data.searchObject[index], item);
              } else {
                form_action += (form_action.indexOf('?') !== -1 ? "&" : "?") + index + "=" + item;
              }
            });
            form.append("<input type='hidden' name='checkout' value='true'>");
            form.attr("action", form_action);
            form.trigger('submit', [{ flitsFormSubmitted: true }]);
      });
    }
  })
}(Flits));
